import createActions from '../../common/services/create-action';

export const SUBSCRIBE_CHANNEL = 'duplexer/SUBSCRIBE_CHANNEL';
export const UNSUBSCRIBE_CHANNEL = 'duplexer/UNSUBSCRIBE_CHANNEL';
export const SEND_EVENT = 'duplexer/SEND_EVENT';

export const subscribeChannel = createActions(SUBSCRIBE_CHANNEL);
export const unsubscribeChannel = createActions(UNSUBSCRIBE_CHANNEL);
export const sendEventToChannel = createActions(SEND_EVENT);
